/// <reference path="../../../public/assets/js/bootstrap.bundle.min.js" />
/// <reference path="../../../public/assets/js/bootstrap.bundle.min.js" />
import React, { Component, useRef, useStat } from "react";
import { withRouter } from "react-router-dom";
import GrievanceHeader from "./General/GrievanceHeader";
import GrievanceAction from "../../store/grievance/action";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import AuthService from "../Auth/AuthService";
import PermissionFeature from "../Permissions/PermissionFeature";

import { MDBInput } from "mdbreact";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import AUX from "../../hoc/Aux_";
import authAxios from "../Shared/auth-header";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import Services from "./GrievanceService";
import moment from "moment";
import $ from "jquery";
import "../Grievances/grievances.css";
import _ from "lodash";
import { toast } from "react-toastify";
import { isMobile } from "react-device-detect";
import { PdfDocument } from "../../modules/Grievances/General/GrievanceStepPDF";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { PARPdfDocument } from "../../modules/Grievances/General/GrievancePARPDF";
import GrievanceDetailsOnlyModal from "./General/GrievanceDetailsOnlyModal";
import GrievanceSearchModal from "./General/GrivanceSearchModal";
import DeleteConfirmModal from "./General/DeleteConfirmModal";
import DeleteBulkConfirmModal from "./General/DeleteBulkConfirmModal";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import GrievanceGridDuplicateForm from "./General/GrievanceGridDuplicateForm";
import GrievanceEditForm from "./General/GrievanceEditForm";
import { PARMultiPdfDocument } from "./General/GrievanceMultiPARPDF";
import Tooltip from "./General/Tooltip";
const filter = createFilterOptions();

class Grievances extends Component {
  pdfRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      sizePerPage: 10,
      page: 1,
      pdfData: {},

      show: false,
      loadState: true,
      showPdf: false,
      customSortApplied: false,
      isClean: true,
      showClearButton: false,
      searchTerm: "",
      searchType: "",
      grievancesData: [],
      completeGrievancesList: [],
      filteredGrievances: [],
      ActiveTab: -1,
      regions: [],
      region: {},
      assignedGRT: {},
      assignedLR: {},
      assignedUserList: [],
      assignedGRTUserList: [],
      facilities: [],
      completeFacilities: [],
      stepsList: [],
      facility: {},
      contractArticles: [],
      contractArticle: {},
      parFAAContacts: [],
      contractList: [],
      articlesList: [],
      grievanceViewOnlyData: [],
      selectedGrievanceForDetail: "",
      selectedGrievanceStatus: "",
      searchTermRegion: "",
      searchTermFacility: "",
      searchTermLR: "",
      searchTermArticle: "",
      showPARPDF: false,
      searchTermContract: "",
      searchTermGRT: "",
      grievanceCount: 0,
      searchTermStatus: "0",
      searchStep: "",

      showDeleteModal: false,
      showDuplicateGrievanceModal: false,
      showEditGrievanceModal: false,
      showBulkDeleteModal: false,
      grievanceIdForDup: 0,
      currentDuplicateGrievanceId: 0,
      currentDuplicateStepId: 0,
      currentEditGrievanceId: 0,
      expanded: [],
      selectedGrievanceForPAR: [],
      selectedGrievancePARDATA: [],
      searchkeyword: "",
      stepsList: ["Step 1", "Step 2", "PAR", "Arbitration", "Expedited"],
      statuses: [
        { statusId: 1, status: "Draft" },
        { statusId: 2, status: "Active" },
        { statusId: 3, status: "Held in Abeyance" },
        { statusId: 4, status: "Remanded" },
        { statusId: 5, status: "Sustained" },
        { statusId: 6, status: "Denied" },
        { statusId: 7, status: "Withdrawn" },
        { statusId: 8, status: "Settled" },

        { statusId: -1, status: "Unknown" },
      ],
      isConfirmModalOpen: false,
      isSearchModalOpen: false,
    };
    this.rowClasses = (row, rowIndex) => {
      let classes = null;
      if (row.status == "Draft") {
        classes = "bg-light-blue";
      }
      if (row.canEdit) {
        classes = "c-pointer";
      }
      if (!row.canEdit) {
        classes = "bg-light-grey";
      }
      return classes;
    };

    this.RemotePagination = this.RemotePagination.bind(this);
    this.SizePerPageChange = this.SizePerPageChange.bind(this);
    this.filterMyRequest = this.filterMyRequest.bind(this);
    this.viewAllLink = this.viewAllLink.bind(this);
    this.getColumn = this.getColumn.bind(this);
    this.sortDataArticles = this.sortDataArticles.bind(this);
    this.handleClearSearch = this.handleClearSearch.bind(this);
    this.changeActiveTab = this.changeActiveTab.bind(this);
    this.expandRow = this.expandRow.bind(this);
    this.OnPageChange = this.OnPageChange.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.expandFirst = this.expandFirst.bind(this);
    this.expandAll = this.expandAll.bind(this);
    this.handlePARMultiPDFDownload = this.handlePARMultiPDFDownload.bind(this);
    this.loadDraftRequestData = this.loadDraftRequestData.bind(this);
    this.closeEditGrievanceModal = this.closeEditGrievanceModal.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.loadAllContracts = this.loadAllContracts.bind(this);
    this.filterArticlesBasedOnContracts = this.filterArticlesBasedOnContracts.bind(
      this
    );
    this.cancelDelete = this.cancelDelete.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.cancelBulkDelete = this.cancelBulkDelete.bind(this);
    this.handleBulkDeleteClick = this.handleBulkDeleteClick.bind(this);
    this.deleteGrievances = this.deleteGrievances.bind(this);
    this.getVisibleColumns = this.getVisibleColumns.bind(this);
    this.loadAllSteps = this.loadAllSteps.bind(this);
  }

  getVisibleColumns() {
    let allColumns = this.getColumn();
    const hidden = allColumns
      .filter((col) => col.hidden)
      .map((col) => col.dataField);
    const visible = allColumns.filter((c) => !hidden.includes(c.dataField));
    const freedWidth = allColumns
      .filter((c) => hidden.includes(c.dataField))
      .reduce((sum, c) => sum + c.tableWidth, 0);

    const extraPerCol =
      !this.hasViewPermission(PermissionFeature.GRGrievant) &&
      this.hasViewPermission(PermissionFeature.GRPARPDF)
        ? (freedWidth + 4) / (visible.length - 1)
        : freedWidth / visible.length;
    return visible.map((c) => {
      if (
        c.dataField == "status" &&
        !this.hasViewPermission(PermissionFeature.GRGrievant) &&
        this.hasViewPermission(PermissionFeature.GRPARPDF)
      ) {
        return {
          ...c,
          headerAttrs: {
            width: c.tableWidth + "%",
          },
        };
      }
      return {
        ...c,
        headerAttrs: {
          width: (c.tableWidth + extraPerCol).toString() + "%",
        },
      };
    });
  }

  closeDuplicateGrievanceModal = () => {
    this.setState({ showDuplicateGrievanceModal: false });
  };

  closeEditGrievanceModal = () => {
    this.setState({ showEditGrievanceModal: false });
  };

  handlePARMultiPDFDownload = () => {
    const pdf = this.pdfRef.current;
    pdf.save();
  };

  expandFirst() {
    let expanded = [];
    if (
      this.state.filteredGrievances &&
      !_.isEmpty(this.state.filteredGrievances)
    ) {
      expanded = [...expanded, "Draft", "Active"];
    }

    this.setState({
      expanded: expanded,
    });
    setTimeout(() => {
      this.setState({ show: true });
    }, 2000);
  }
  expandAll() {
    let expanded = [];
    if (
      this.state.filteredGrievances &&
      !_.isEmpty(this.state.filteredGrievances)
    ) {
      this.state.filteredGrievances.forEach((item) => {
        expanded = [...expanded, item.status];
      });
    }

    this.setState({
      expanded: expanded,
    });
    setTimeout(() => {
      this.setState({ show: true });
    }, 2000);
  }
  changeActiveTab(value) {
    this.setState({ ActiveTab: value });
  }
  toggleConfirmModal = () => {
    this.setState({ isConfirmModalOpen: !this.state.isConfirmModalOpen });
  };
  toggleSearchModel = () => {
    this.setState({ isSearchModalOpen: !this.state.isSearchModalOpen });
  };
  loadDraftRequestData = async (id) => {
    $(".loading").show();
    let result = await Services.LoadGrievanceDataById(id);
    $(".loading").hide();

    if (result != null) {
      let {
        grievant,
        representative,
        articles,
        steps,
        recipient,
      } = result.data;
      const DraftKey = "CreateGrievanceForm";
      let articlesData = null;
      if (articles && articles != null && articles.length > 0) {
        articlesData = articles.map((x) => ({
          contractId: x.contractId,
          id: x.id,
          name: "Article " + x.articleIndex + " - " + x.articleName,
        }));
      }
      let greivantdata =
        grievant && grievant != null && grievant != undefined
          ? {
              id: grievant.id,
              memberNumber: grievant.membernumber,

              name:
                grievant.firstname +
                " " +
                (grievant.middlename ? grievant.middlename + " " : "") +
                grievant.lastname,
              firstName: grievant.firstname,
              lastName: grievant.lastname,
              nickName: grievant.nickname,
              previousLastName: grievant.previouslastname,
              email: null,
              phoneTypeID: null,
              phone: null,
              regionID: null,

              facilityID: null,
              facility: grievant.facility ? grievant.facility.code : null,

              region: grievant.region ? grievant.region.code : null,
              memberType: grievant.membertype
                ? grievant.membertype.description
                : null,
              memberTypeID: grievant.membertypeid,
              status: grievant.status,
              faaID: null,
            }
          : null;
      let representativeData =
        representative && representative != null && representative != undefined
          ? {
              id: representative.id,
              name:
                representative.firstname +
                " " +
                (representative.middlename
                  ? representative.middlename + " "
                  : "") +
                representative.lastname,
            }
          : null;
      let recipientData =
        recipient && recipient != null && recipient != undefined
          ? {
              id: recipient.id,
              name: recipient.recipientName,
            }
          : null;
      let createFormVariable = {
        id: id,
        grievant: greivantdata,
        articles: articlesData,
        representative: representativeData,
        recipient: recipientData,
        isUnion: result.data.isUnion,
        contract: "",
        grievant_err: "",
        representative_err: "",
        recipient_err: "",
        dateOfVoilation_err: "",
        dateSubmitted_err: "",
        contract_err: "",
        statementOfFacts_err: "",
        subject_err: "",
        remedySought_err: "",
        facility_err: "",
        files: [],
        filesTable: [],
      };
      let stepsData =
        steps && steps != undefined && steps != null && steps.length > 0
          ? {
              currentStep: steps[0].stepName,
              step1Active: steps[0].stepName == "Step 1",
              isAdverse: steps[0].isAdverse,
              isMeeting: steps[0].isMeeting,
              dateOfVoilation:
                steps[0].dateOfVoilation != "1/1/0001"
                  ? steps[0].dateOfVoilation
                  : null,
              dateSubmitted:
                steps[0].dateSubmitted != "1/1/0001"
                  ? steps[0].dateSubmitted
                  : null,
              meetingDate:
                steps[0].meetingDate != "1/1/0001"
                  ? steps[0].meetingDate
                  : null,
              subject: steps[0].subject,
              FAANumber: steps[0].fAANumber,
              statementOfFacts: steps[0].statementOfFacts,
              stepId: steps[0].stepId,
              remedySought: steps[0].remedySought,
            }
          : null;
      if (stepsData) {
        createFormVariable = { ...createFormVariable, ...stepsData };
      }
      localStorage.setItem(DraftKey, JSON.stringify(createFormVariable));
      this.props.history.push("/Grievances/addGrievance");
      this.changeActiveTab(2);
    }
  };
  async loadAllRequests() {
    $(".loading").show();
    let grievancesList = [];
    await this.setState({
      loadState: true,
      filteredGrievances: [],
    });
    let result = await Services.LoadAllGrievances(true);
    if (!_.isEmpty(result.data)) {
      _.forEach(result.data, function(el, index, arr) {
        grievancesList.push({
          dateFiled: el.dateFiled,
          facilityId: el.facilityId,
          facilityCode: el.facilityCode,
          facility: isMobile ? el.facilityCode : el.facilityName,
          grievanceId: el.grievanceId,
          region: el.regionName,
          assignedUserName: el.assignedUserName,
          assignedGRTUserName: el.assignedGRTUserName,
          assignedGRTUserId: el.assignedGRTUserId,
          assignedUserId: el.assignedUserId,
          articleName: el.articleName,
          articles: el.articles,
          articleId: el.articleId,
          contractId: el.contractId,
          isUnion: el.isUnion,
          gId: el.id,
          grievant: el.grievantName,
          regionId: el.regionId,
          status: el.status,
          step: el.step,
          canEdit: el.canEdit,
          representativeName: el.representativeName,
          subject: el.grievanceSubject,
          remainingDays: parseInt(el.daysRemainingForNextDueDate),
          pdfData: el.pdfData ? el.pdfData : null,
        });
      });
      this.setState({
        filteredGrievances: this.arrangeDataWithStatus(
          _.cloneDeep(grievancesList),
          10,
          1
        ),
        completeGrievancesList: grievancesList,
        grievancesData: grievancesList,
        sizePerPage: 10,
        customSortApplied: true,
        page: 1,
        grievanceCount: grievancesList.length,
      });
    }

    await this.setState({
      loadState: false,
    });
    this.expandFirst();
    $(".loading").hide();

    await this.setState({
      filteredGrievances: this.arrangeDataWithStatus(
        _.cloneDeep(grievancesList),
        this.state.sizePerPage,
        1
      ),
      page: 1,
      grievancesData: grievancesList,
    });
    this.expandFirst();
  }
  arrangeDataWithStatus(List, sizePerPage, page) {
    let start = (page - 1) * sizePerPage,
      end = (page - 1) * sizePerPage - 1 + sizePerPage + 1;
    $(".loading").show();
    let List2 = List;
    if (this.state.customSortApplied == false) {
      List2 = _.orderBy(
        List2,
        [
          (item) => (item.status === "Draft" ? 0 : 1), // Make "Draft" come first
          "status",
          "remainingDays",
          "gId",
        ],
        ["asc", "asc", "asc", "desc"]
      );
    }
    List2 = List2.slice(start, end);
    let result = this.state.statuses
      .map((x) => {
        let data = List2.filter((y) => y.status == x.status);
        if (data && data.length > 0) {
          return {
            status: x.status,
            grievances: data,
          };
        }
      })
      .filter((el) => el);
    $(".loading").hide();
    return result;
  }
  loadMembersByRegion(regionId, searchTerm, searchType, region) {
    Services.GetLRRepresentatives(regionId).then((result) => {
      if (!_.isEmpty(result.data)) {
        var UserList = [];
        result.data.map((item) => {
          UserList.push({
            assignedUserName: item.firstname + " " + item.lastname,
          });
        });
        this.setState({
          assignedUserList: UserList,
          searchType: searchType,
          searchTerm: searchTerm,
          region: region,
        });
        //this.state.assignedUserList = UserList;
      }
    });
  }
  loadGRTMembers() {
    Services.GetGRTRepresentatives().then((result) => {
      if (!_.isEmpty(result.data)) {
        var GRTUserList = [];
        result.data.map((item) => {
          GRTUserList.push({
            assignedGRTUserName: item.firstname + " " + item.lastname,
          });
        });
        this.setState({
          assignedGRTUserList: GRTUserList,
        });
      }
    });
  }
  loadAllSteps = async () => {
    var listSteps = await Services.GetSteps();
    if (listSteps != null) {
      await this.setState({ stepsList: listSteps });
    }
  };
  loadRegions() {
    let regionsList = [];
    authAxios.get("/api/Grievance/GetRegions").then(({ data }) => {
      if (!_.isEmpty(data.data)) {
        _.forEach(data.data, function(el, index, arr) {
          regionsList.push({
            regionId: el.id,
            region: el.code == "NAT" ? "HQ" : el.code,
          });
        });
        this.setState({
          regions: regionsList,
        });
        let facilityList = [];
        authAxios.get("api/Grievance/GetFacilities/0").then(({ data }) => {
          if (!_.isEmpty(data.data)) {
            _.forEach(data.data, function(el, index, arr) {
              facilityList.push({
                facilityId: el.id,
                facility: el.code == "NAT" ? "HQ" : el.code,
                regionId: el.regionid,
              });
            });
            if (!_.isEqual(this.state.facilities, facilityList)) {
              this.setState({
                facilities: facilityList,
                completeFacilities: facilityList,
              });
            }
          }
        });
      }
    });
  }
  loadArticles() {
    let articlesList = [];
    authAxios.get("/api/Grievance/GetAllArticles").then(({ data }) => {
      if (!_.isEmpty(data.data)) {
        this.setState({
          articlesList: data.data,
        });
      }
    });
  }
  async filterArticlesBasedOnContracts(contractIdString) {
    let articlesList = [];
    const contractId = parseInt(contractIdString, 10);
    if (!_.isEmpty(this.state.articlesList)) {
      articlesList = this.state.articlesList
        .filter((el) => el.contractId === contractId) // Filter the articles by contractId
        .map((el) => ({
          articleId: el.id, // Map to the required format
          articleName:
            "Article - " + el.articleIndex + ", " + el.articleName.trim(), // Trim any extra spaces
        }));
    }
    await this.setState({
      contractArticles: articlesList,
      searchTermContract: contractId,
    });
  }
  async loadAllContracts() {
    let contractList = [];
    let data = await Services.loadAllContracts();
    if (!_.isEmpty(data.data)) {
      _.forEach(data.data, function(el, index, arr) {
        contractList.push({
          id: el.id,
          contractName: el.contractName,
        });
      });
      this.setState({
        contractList: contractList,
      });
    }
  }
  async loadParFAAContact() {
    let contactList = await Services.LoadPARFAAContacts();
    if (contactList != null) {
      await this.setState({ parFAAContacts: contactList });
    }
  }
  componentDidMount() {
    this.loadRegions();
    this.loadGRTMembers();
    this.loadAllRequests();
    this.loadArticles();
    this.loadAllContracts();
    this.loadParFAAContact();
    this.loadAllSteps();
    var grievanceCreateSuccessMsg = this.props.history.location.toastMsg;
    if (!_.isEmpty(grievanceCreateSuccessMsg)) {
      $(".loading").hide();
      toast.success(grievanceCreateSuccessMsg);
      this.setState({ ActiveTab: 1 });
    }
  }
  rowEvents = {
    onClick: (e, row, rowIndex) => {
      e.preventDefault();
      e.nativeEvent.stopImmediatePropagation();
      this.props.history.push({
        pathname: "/grievances/" + row.grievanceId,
        type: "create",
        uid: row.id,
      });
    },
  };
  getMeetingDate = (steps, currentStepName) => {
    var meetingStep = steps.filter(function(el) {
      return el.stepName == currentStepName + " Meeting";
    });
    if (meetingStep.length > 0) {
      return meetingStep[0].meetingDate;
    } else return "";
  };
  handleDeleteClick = async (e, item) => {
    e.preventDefault();
    e.nativeEvent.stopImmediatePropagation();
    await this.setState({ showDeleteModal: true, itemToDelete: item });
  };
  handleBulkDeleteClick = async (e, item) => {
    e.preventDefault();
    e.nativeEvent.stopImmediatePropagation();
    await this.setState({ showBulkDeleteModal: true });
  };
  confirmDelete = async () => {
    const { itemToDelete } = this.state;
    $(".loading").show();
    if (await Services.DeleteGrievance(itemToDelete.grievanceId)) {
      this.loadAllRequests();
    }
    $(".loading").hide();
    await this.setState({ showDeleteModal: false, itemToDelete: null });
  };
  cancelBulkDelete = () => {
    this.setState({ showBulkDeleteModal: false });
  };
  cancelDelete = () => {
    this.setState({ showDeleteModal: false, itemToDelete: null });
  };
  getResponseDate = (steps, currentStepName) => {
    var responseStep = steps.filter(function(el) {
      return el.stepName == currentStepName + " Response";
    });
    if (responseStep.length > 0) {
      return responseStep[0].responseDate;
    } else return "";
  };
  reActiveGrievance = (grievanceGeneratedId) => {};
  openInformationModal = (grievanceId) => {
    $(".loading").show();
    Services.LoadGrievanceDataById(grievanceId).then((result) => {
      var viewGrievanceStepObjects = [];
      var stepsCreated = "";
      this.state.stepsList.forEach((element) => {
        result.data.steps.forEach((step) => {
          if (
            step.stepName.indexOf(element) > -1 &&
            stepsCreated.indexOf(element) == -1
          ) {
            var viewGrievanceObject = {
              subject: step.subject,
              recipientName: result.data.recipient.recipientName,
              violation: step.articleVoilated,
              grievant:
                result.data.grievant.firstname +
                " " +
                result.data.grievant.lastname,
              statementOfFact: step.statementOfFacts,
              remedySought: step.remedySought,
              stepName: step.stepName,
              isMeeting: step.isMeeting ? "True" : "False",
              fAANumber: step.fAANumber,
              isAdverse: step.isAdverse ? "True" : "False",
              meetingDate: !step.isMeeting
                ? ""
                : this.getMeetingDate(result.data.steps, step.stepName),
              responseDate: this.getResponseDate(
                result.data.steps,
                step.stepName
              ),
              stepType: step.stepType,
              withdrawReason: result.data.WithdrawReason,
            };
            stepsCreated += step.stepName;
            viewGrievanceStepObjects.push(viewGrievanceObject);
          }
        });
      });
      this.setState({
        isConfirmModalOpen: !this.state.isConfirmModalOpen,
        grievanceViewOnlyData: viewGrievanceStepObjects,
        selectedGrievanceStatus: result.data.grievanceStatus,
        selectedGrievanceForDetail: result.data.grievanceGeneratedId,
      });
      $(".loading").hide();
    });
  };
  handleDuplicateClick = async (e, id) => {
    e.preventDefault();
    e.nativeEvent.stopImmediatePropagation();
    if (id != 0) {
      await Services.GetStepIdByGrievanceId(id).then((data) => {
        this.setState({
          currentDuplicateGrievanceId: id,
          currentDuplicateStepId: data.id,
          showDuplicateGrievanceModal: true,
        });
      });
    }
  };
  handleEditClick = async (e, id) => {
    e.preventDefault();
    e.nativeEvent.stopImmediatePropagation();
    if (id != 0) {
      await this.setState({
        currentEditGrievanceId: id,
        showEditGrievanceModal: true,
      });
    }
  };

  sortData = (grievancesData, sortField, sortOrder) => {
    const data = grievancesData;

    return data.sort((a, b) => {
      const aValue = a[sortField];
      const bValue = b[sortField];

      // Implement your custom sorting logic here
      // This example uses localeCompare for alphanumeric sorting
      return sortOrder === "asc"
        ? aValue.localeCompare(bValue, "en", {
            numeric: true,
            sensitivity: "base",
          })
        : bValue.localeCompare(aValue, "en", {
            numeric: true,
            sensitivity: "base",
          });
    });
  };
  sortDataArticles = (grievancesData, sortOrder) => {
    const data = grievancesData;

    return data.sort((a, b) => {
      // Assuming each item in completeGrievancesList has an 'article' property
      const articleIndexA =
        a.articles && !_.isEmpty(a.articles) ? a.articles[0].articleIndex : 0;
      const articleIndexB =
        b.articles && !_.isEmpty(b.articles) ? b.articles[0].articleIndex : 0;
      if (sortOrder === "asc") {
        return articleIndexA - articleIndexB;
      } else {
        return articleIndexB - articleIndexA;
      }
    });
  };
  handleTableChange = async (
    type,
    { sortField, sortOrder, data, page, sizePerPage }
  ) => {
    ///debugger;
    if (type === "sort") {
      let sortedData = [];
      if (sortField == "gId") {
        sortedData = this.sortData(
          this.state.grievancesData,
          sortField,
          sortOrder
        );
        this.state.completeGrievancesList = this.sortData(
          this.state.completeGrievancesList,
          sortField,
          sortOrder
        );
      } else if (sortField == "articleName") {
        sortedData = this.sortDataArticles(
          this.state.grievancesData,
          sortOrder
        );
        this.state.completeGrievancesList = this.sortDataArticles(
          this.state.completeGrievancesList,

          sortOrder
        );
      } else {
        sortedData = _.orderBy(
          this.state.grievancesData,
          [sortField],
          [sortOrder]
        );
        this.state.completeGrievancesList = _.orderBy(
          this.state.completeGrievancesList,
          [sortField],
          [sortOrder]
        );
      }
      let expanded = [];
      this.state.statuses.forEach((item) => {
        expanded = [...expanded, item.status];
      });
      await this.setState({ expanded: expanded });
      await this.setState({
        completeGrievancesList: this.state.completeGrievancesList,
        grievancesData: this.state.grievancesData,
        filteredGrievances: this.arrangeDataWithStatus(
          sortedData,
          this.state.sizePerPage,
          this.state.page
        ),
        customSortApplied: true,
      });
    }
  };
  // Updated helper functions without canSP
  hasViewPermission = (feature) => {
    return AuthService.canView(feature) || AuthService.canOwnView(feature);
  };

  hasAddPermission = (feature) => {
    return AuthService.canAdd(feature) || AuthService.canOwnAdd(feature);
  };

  hasUpdatePermission = (feature) => {
    return AuthService.canUpdate(feature) || AuthService.canOwnUpdate(feature);
  };

  hasDeletePermission = (feature) => {
    return AuthService.canDelete(feature) || AuthService.canOwnDelete(feature);
  };
  expandRow = () => {
    let allColumns = this.getColumn();
    const hidden = allColumns
      .filter((col) => col.hidden)
      .map((col) => col.dataField);
    const visible = allColumns.filter((c) => !hidden.includes(c.dataField));
    const freedWidth = allColumns
      .filter((c) => hidden.includes(c.dataField))
      .reduce((sum, c) => sum + c.tableWidth, 0);

    const extraPerCol =
      !this.hasViewPermission(PermissionFeature.GRGrievant) &&
      this.hasViewPermission(PermissionFeature.GRPARPDF)
        ? (freedWidth + 4) / (visible.length - 1)
        : freedWidth / visible.length;

    return {
      renderer: (row) => {
        return (
          <>
            {!_.isEmpty(row.grievances) &&
              row.grievances.map((item, index) => {
                let perm_FacilityCode = this.hasViewPermission(
                  PermissionFeature.FacilityCode
                );
                let perm_FacilityDescription = this.hasViewPermission(
                  PermissionFeature.FacilityDescription
                );
                let facility = perm_FacilityCode
                  ? item.facilityCode +
                    (perm_FacilityDescription ? " (" + item.facility + ")" : "")
                  : perm_FacilityDescription
                  ? item.facility
                  : "";

                return (
                  <div
                    key={"expend-" + row.status + "-" + index}
                    className="d-flex px-0 w-100 border-top c-pointer border-bottom"
                    onClick={(e) => {
                      if (
                        e.target.hasAttribute("data-grievanceid") ||
                        e.target.hasAttribute("data-GrievanceAction")
                      ) {
                        // do nothing everything will be done on checkbox event
                      } else {
                        if (row.status == "Draft") {
                          this.loadDraftRequestData(item.grievanceId);
                        } else {
                          this.grievancePage(e, item.grievanceId);
                        }
                      }
                    }}
                  >
                    {isMobile ? (
                      <>
                        {this.hasViewPermission(
                          PermissionFeature.GRGrievant
                        ) && (
                          <div
                            className="px-3 py-2 border-right"
                            style={{ width: 25 + extraPerCol + "%" }}
                          >
                            {this.hasViewPermission(
                              PermissionFeature.GRGrievant
                            ) && <> {item.isUnion ? "NATCA" : item.grievant}</>}
                          </div>
                        )}
                        {this.hasViewPermission(
                          PermissionFeature.GRDateFiled
                        ) && (
                          <div
                            className="px-3 py-2 border-left border-right"
                            style={{ width: 30 + extraPerCol + "%" }}
                          >
                            {this.hasViewPermission(
                              PermissionFeature.GRDateFiled
                            ) && (
                              <>
                                {" "}
                                {moment(item.dateFiled).isValid()
                                  ? moment(item.dateFiled).format("MM/DD/YYYY")
                                  : ""}
                              </>
                            )}
                          </div>
                        )}
                        {this.hasViewPermission(
                          PermissionFeature.RegionCode
                        ) && (
                          <div
                            className="px-3 py-2 border-left border-right"
                            style={{ width: 22 + extraPerCol + "%" }}
                          >
                            {this.hasViewPermission(
                              PermissionFeature.RegionCode
                            ) && <> {item.region}</>}
                          </div>
                        )}
                        {this.hasViewPermission(
                          PermissionFeature.FacilityCode
                        ) && (
                          <div
                            className="px-3 py-2 border-left border-right"
                            style={{ width: 23 + extraPerCol + "%" }}
                          >
                            {this.hasViewPermission(
                              PermissionFeature.FacilityCode
                            ) && <> {item.facility}</>}
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        {this.hasViewPermission(PermissionFeature.GRPARPDF) && (
                          <div
                            className="px-3 py-2 text-center border-right"
                            data-grievanceId={item.grievanceId}
                            style={{
                              width:
                                (!this.hasViewPermission(
                                  PermissionFeature.GRGrievant
                                )
                                  ? "6"
                                  : "4") + "%",
                            }}
                          >
                            {(this.hasViewPermission(
                              PermissionFeature.GRPARPDF
                            ) ||
                              this.hasDeletePermission(
                                PermissionFeature.GRRequests
                              )) && (
                              <input
                                type="checkbox"
                                data-grievanceId={item.grievanceId}
                                onClick={(e) => {
                                  this.updateGrievancePARList(item);
                                }}
                                class="1"
                                checked={
                                  !_.isEmpty(this.state.selectedGrievanceForPAR)
                                    ? _.some(
                                        this.state.selectedGrievanceForPAR,
                                        (x) => x.id === item.grievanceId
                                      )
                                    : false
                                }
                              />
                            )}
                          </div>
                        )}

                        {this.hasViewPermission(
                          PermissionFeature.GRGrievant
                        ) && (
                          <div
                            className="px-3 py-2 border-right"
                            style={{
                              width:
                                6 +
                                extraPerCol +
                                (!this.hasViewPermission(
                                  PermissionFeature.GRPARPDF
                                )
                                  ? 4
                                  : 0) +
                                "%",
                            }}
                          >
                            {this.hasViewPermission(
                              PermissionFeature.GRGrievant
                            ) && <> {item.isUnion ? "NATCA" : item.grievant}</>}
                          </div>
                        )}

                        {this.hasViewPermission(
                          PermissionFeature.GRDateFiled
                        ) && (
                          <div
                            className="px-3 py-2 border-left border-right"
                            style={{ width: 10 + extraPerCol + "%" }}
                          >
                            {this.hasViewPermission(
                              PermissionFeature.GRDateFiled
                            ) && (
                              <>
                                {" "}
                                {moment(item.dateFiled).isValid()
                                  ? moment(item.dateFiled).format("MM/DD/YYYY")
                                  : ""}
                              </>
                            )}
                          </div>
                        )}

                        {this.hasViewPermission(
                          PermissionFeature.RegionCode
                        ) && (
                          <div
                            className="px-3 py-2 border-left border-right"
                            style={{ width: 7 + extraPerCol + "%" }}
                          >
                            {this.hasViewPermission(
                              PermissionFeature.RegionCode
                            ) && <> {item.region}</>}
                          </div>
                        )}
                        {(this.hasViewPermission(
                          PermissionFeature.FacilityCode
                        ) ||
                          this.hasViewPermission(
                            PermissionFeature.FacilityDescription
                          )) && (
                          <div
                            className="px-3 py-2 border-left border-right"
                            style={{ width: 10 + extraPerCol + "%" }}
                          >
                            {facility}
                          </div>
                        )}

                        {this.hasViewPermission(PermissionFeature.GRSteps) && (
                          <div
                            className="px-3 py-2 border-left border-right"
                            style={{ width: 8 + extraPerCol + "%" }}
                          >
                            {this.hasViewPermission(
                              PermissionFeature.GRSteps
                            ) && <> {item.step}</>}
                          </div>
                        )}

                        {this.hasViewPermission(
                          PermissionFeature.GRSubject
                        ) && (
                          <div
                            className="px-3 py-2 border-left border-right"
                            style={{ width: 10 + extraPerCol + "%" }}
                          >
                            {this.hasViewPermission(
                              PermissionFeature.GRSubject
                            ) && <>{item.subject}</>}
                          </div>
                        )}

                        {this.hasViewPermission(
                          PermissionFeature.GRRepresentative
                        ) && (
                          <div
                            className="px-3 py-2 border-left border-right"
                            style={{ width: 13 + extraPerCol + "%" }}
                          >
                            {this.hasViewPermission(
                              PermissionFeature.GRRepresentative
                            ) && <> {item.representativeName}</>}
                          </div>
                        )}

                        {this.hasViewPermission(
                          PermissionFeature.GRContractArticle
                        ) && (
                          <div
                            className="px-3 py-2 border-left border-right"
                            style={{ width: 10 + extraPerCol + "%" }}
                          >
                            {item.articles &&
                              this.hasViewPermission(
                                PermissionFeature.GRContractArticle
                              ) &&
                              !_.isEmpty(item.articles) &&
                              item.articles.map((x) => (
                                <Tooltip text={x.articleName}>
                                  <span
                                    className="badge badge-pill c-pointer badge-success"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      e.nativeEvent.stopImmediatePropagation();
                                    }}
                                  >
                                    Article - {x.articleIndex}{" "}
                                  </span>
                                </Tooltip>
                              ))}
                          </div>
                        )}

                        {this.hasViewPermission(
                          PermissionFeature.GRRemainingDays
                        ) &&
                          (() => {
                            if (!item.remainingDays) {
                              return (
                                <div
                                  className="px-3 py-2 border-left border-right"
                                  style={{ width: 7 + extraPerCol + "%" }}
                                >
                                  No Record
                                </div>
                              );
                            }
                            if (item.remainingDays < 5) {
                              return (
                                <div
                                  className="px-3 py-2 border-left border-right"
                                  style={{
                                    backgroundColor: "red",
                                    color: "white",
                                    width: 7 + extraPerCol + "%",
                                  }}
                                >
                                  {item.remainingDays} Days
                                </div>
                              );
                            } else if (item.remainingDays < 10) {
                              return (
                                <div
                                  className="px-3 py-2 border-left border-right bg-warning text-light"
                                  style={{ width: 7 + extraPerCol + "%" }}
                                >
                                  {item.remainingDays} Days
                                </div>
                              );
                            } else {
                              return (
                                <div
                                  className="px-3 py-2 border-left border-right"
                                  style={{ width: 7 + extraPerCol + "%" }}
                                >
                                  {item.remainingDays} Days
                                </div>
                              );
                            }
                          })()}

                        {this.hasViewPermission(
                          PermissionFeature.Grievances
                        ) && (
                          <div
                            className="px-3 py-2 border-left border-right"
                            style={{ width: 10 + extraPerCol + "%" }}
                          >
                            {this.hasViewPermission(
                              PermissionFeature.Grievances
                            ) && <>{item.gId}</>}
                          </div>
                        )}

                        {(this.hasViewPermission(
                          PermissionFeature.GRPDFReport
                        ) ||
                          this.hasAddPermission(PermissionFeature.GRRequests) ||
                          this.hasUpdatePermission(
                            PermissionFeature.GRRequests
                          ) ||
                          this.hasDeletePermission(
                            PermissionFeature.GRRequests
                          )) && (
                          <div
                            className="px-2 text-center py-2 border-left"
                            style={{ width: 5 + extraPerCol + "%" }}
                          >
                            {(item.status == "Draft"
                              ? this.hasAddPermission(
                                  PermissionFeature.GRRequests
                                )
                              : this.hasUpdatePermission(
                                  PermissionFeature.GRRequests
                                )) && (
                              <>
                                {this.state.show ? (
                                  <span
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.nativeEvent.stopImmediatePropagation();
                                      e.stopPropagation();
                                    }}
                                  >
                                    <i
                                      onClick={(e) => {
                                        this.handleEditClick(
                                          e,
                                          item.grievanceId
                                        );
                                      }}
                                      data-GrievanceAction={true}
                                      className="pr-2 fas fa-edit text-primary c-pointer"
                                    />
                                  </span>
                                ) : (
                                  <i className="fas fa-spinner" />
                                )}
                              </>
                            )}

                            {this.hasAddPermission(
                              PermissionFeature.GRRequests
                            ) && (
                              <>
                                {this.state.show ? (
                                  <>
                                    <i
                                      onClick={(e) => {
                                        this.handleDuplicateClick(
                                          e,
                                          item.grievanceId
                                        );
                                      }}
                                      data-GrievanceAction={true}
                                      className="pr-2 fas fa-files-o text-primary c-pointer"
                                    />
                                  </>
                                ) : (
                                  <i className="fas fa-spinner" />
                                )}
                              </>
                            )}

                            {this.hasDeletePermission(
                              PermissionFeature.GRRequests
                            ) && (
                              <>
                                {this.state.show ? (
                                  <>
                                    <i
                                      onClick={(e) => {
                                        this.handleDeleteClick(e, item);
                                      }}
                                      data-GrievanceAction={true}
                                      className="pr-2 fas fa-trash text-primary c-pointer"
                                    />
                                  </>
                                ) : (
                                  <i className="fas fa-spinner" />
                                )}
                              </>
                            )}

                            {this.hasViewPermission(
                              PermissionFeature.GRPDFReport
                            ) && (
                              <>
                                {this.state.show ? (
                                  <PDFDownloadLink
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.nativeEvent.stopImmediatePropagation();
                                    }}
                                    data-GrievanceAction={true}
                                    document={
                                      <PdfDocument data={item.pdfData} />
                                    }
                                    fileName={item.gId + ".pdf"}
                                  >
                                    <i class="fas fa-file-pdf" />
                                  </PDFDownloadLink>
                                ) : (
                                  <i className="fas fa-spinner" />
                                )}
                              </>
                            )}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                );
              })}
          </>
        );
      },
      onExpand: async (row, isExpand, rowIndex, e) => {
        await this.setState({ show: false });
        if (isExpand) {
          await this.setState(() => ({
            expanded: [...this.state.expanded, row.status],
          }));
        } else {
          await this.setState(() => ({
            expanded: this.state.expanded.filter((x) => x !== row.status),
          }));
        }
        setTimeout(() => {
          this.setState({ show: true });
        }, 2000);
      },
      expanded: this.state.expanded,
      onlyOneExpanding: true,
    };
  };
  grievancePage = (e, id) => {
    if (
      e.target.className.indexOf("pdf") == -1 &&
      e.target.className.indexOf("fa-files-o") < 0
    ) {
      this.props.history.push({
        pathname: "/grievances/" + id,
        type: "create",
        uid: id,
      });
    }
  };

  async deleteGrievances() {
    $(".loading").show();
    const ids = this.state.selectedGrievanceForPAR
      .filter((x) => x.allowedPAR)
      .map((x) => x.id)
      .join(",");
    const result = await Services.DeleteMultipleGrievances(ids);
    await this.setState({
      showBulkDeleteModal: false,
    });
    $(".loading").hide();
    if (result != null) {
      await this.setState({
        selectedGrievancePARDATA: [],
        selectedGrievanceForPAR: [],

        showPARPDF: false,
      });
      this.loadAllRequests();
    }
  }

  async updateGrievancePARList(item) {
    let id = item.grievanceId,
      subject = item.subject,
      regionId = item.regionId;
    let allowedDelete = this.hasDeletePermission(PermissionFeature.GRRequests),
      allowedPAR = this.hasViewPermission(PermissionFeature.GRPARPDF);

    let source = [...this.state.selectedGrievanceForPAR];
    // tracker for already-warned subjects
    this.warnedSubjects = this.warnedSubjects || [];

    // check if already exists
    const exists = source.find((x) => x.id === id);
    let remove = false;
    if (exists) {
      // remove if already in list
      remove = true;
      _.remove(source, (x) => x.id === id);
      // also remove from warnedSubjects
      _.remove(this.warnedSubjects, (warnId) => warnId === id);
    } else {
      // push new entry
      source.push({ id, regionId, subject, allowedPAR, allowedDelete });
    }

    // reset if empty
    if (_.isEmpty(source)) {
      await this.setState({
        selectedGrievancePARDATA: [],
        selectedGrievanceForPAR: [],
        showPARPDF: false,
        parPDFRegion: null,
      });
      return;
    } else {
      await this.setState({ selectedGrievanceForPAR: source });
    }
    // Ensure all selected grievances belong to the same region
    const uniqueRegions = _.uniq(source.map((x) => x.regionId));
    if (uniqueRegions.length > 1) {
      await this.setState({
        showPARPDF: false,
        selectedGrievancePARDATA: [],
        parPDFRegion: null,
      });
      return;
    }
    let { regions } = this.state;
    // If all selected items share the same region, save the region name
    const matched = regions.find((r) => r.regionId === source[0].regionId);

    const commonRegion = matched ? matched.region : null;
    await this.setState({ parPDFRegion: commonRegion });

    if (!remove && allowedPAR) {
      let checkRegionIsAppropriate =
        item.region &&
        _.some(
          this.state.parFAAContacts,
          (x) =>
            (x.regionCode || "").toLowerCase().trim() ===
            (item.region || "").toLowerCase().trim()
        );
      if (!checkRegionIsAppropriate) {
        await this.setState({
          showPARPDF: false,
          selectedGrievancePARDATA: [],
        });

        if (!this.warnedSubjects.includes(id)) {
          this.warnedSubjects.push(id);
        }
        return;
      }
    } else {
      if (!this.warnedSubjects.includes(id)) {
        this.warnedSubjects.push(id);
      }
      return;
    }

    // fetch data
    const ids = source
      .filter((x) => x.allowedPAR)
      .map((x) => x.id)
      .join(",");
    const result = await Services.FetchGrievancesPDFData(ids);
    let hasRemoveIds = false;
    if (!_.isEmpty(result.removeIds)) {
      hasRemoveIds = true;
      result.removeIds.forEach((rmId) => {
        const invalid = _.find(source, (x) => x.id === rmId);
        if (invalid && !this.warnedSubjects.includes(invalid.id)) {
          this.warnedSubjects.push(invalid.id);
        }
      });
    }

    // final state update
    await this.setState({
      selectedGrievancePARDATA: result.data || [],
      showPARPDF: !hasRemoveIds && source.length > 0,
    });
  }
  RemotePagination(
    columns,
    keyFields,
    data,
    SizePerPageChange,
    sizePerPage,
    rowClasses
  ) {
    const customTotal = (from, to, size) => (
      <span
        className="react-bootstrap-table-pagination-total"
        style={{ float: "left", marginTop: "-1px", marginRight: "4px" }}
      >
        {from}
        {" - "}
        {to} of {size} {"   "}
        <b style={{ marginLeft: "4px" }}> Show: </b>
      </span>
    );
    const defaultPaginationConfigs = paginationFactory({
      paginationTotalRenderer: customTotal,
      onSizePerPageChange: this.SizePerPageChange,
      onPageChange: this.OnPageChange,
      sizePerPage: this.state.sizePerPage,
      page: this.state.page,
      totalSize: this.state.grievanceCount,
      showTotal: true,
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "25",
          value: 25,
        },
        {
          text: "30",
          value: 30,
        },
        {
          text: "50",
          value: 50,
        },
        {
          text: "All",
          value: this.state.grievanceCount, //data.length,
        },
      ],
    });

    return (
      <div>
        <BootstrapTable
          remote
          //keyField={keyFields}
          keyField={"status"}
          data={data}
          columns={columns}
          id="GrievanceTable"
          onTableChange={this.handleTableChange}
          classes="expandable"
          pagination={defaultPaginationConfigs}
          rowClasses={rowClasses}
          expandRow={this.expandRow()}
          ///defaultSorted={[{ dataField: "gId", order: "desc" }]}
        />
      </div>
    );
  }

  async getPDFData(grievanceId) {
    var url = `api/Grievance/GetPDFDataByGrievanceId/${grievanceId}`;
    await authAxios.get(url).then(({ data: response }) => {
      this.setState({
        pdfData: response.data,
        showPdf: true,
      });
    });
  }
  handleDelete(row, event) {
    Services.DeleteGrievance(row.grievanceId).then((data) => {
      if (!_.isEmpty(data.status)) {
        if (data.status == "Success") {
          toast.success(data.message);
          this.loadAllRequests();
        } else {
          toast.error(data.message);
        }
      }
    });
  }

  getColumn() {
    return isMobile
      ? [
          {
            dataField: "status",
            text: "Grievant",
            tableWidth: 25,
            expandWidth: 25,
            hidden: !this.hasViewPermission(PermissionFeature.GRGrievant),
            headerClasses: "bg-primary text-white px-sm-3 px-2 py-2",
            sort: true,
            onSort: async (field, order) => {
              this.state.grievancesData = _.orderBy(
                this.state.grievancesData,
                ["grievant"],
                [order]
              );
              await this.setState({
                grievancesData: this.state.grievancesData,
                filteredGrievances: this.arrangeDataWithStatus(
                  this.state.grievancesData,
                  this.state.sizePerPage,
                  this.state.page
                ),
              });
            },
            classes:
              "c-pointer px-3 py-2 border-right-0 bg-secondary text-white",
            formatter: null,
          },
          {
            text: "Date Filed",
            dataField: "dateFiled",
            hidden: !this.hasViewPermission(PermissionFeature.GRDateFiled),
            tableWidth: 30,
            expandWidth: 30,
            headerClasses: "bg-primary text-white px-sm-3 px-2 py-2",
            sort: true,
            classes:
              "c-pointer px-3 py-2 border-right-0 border-left-0 bg-secondary text-white",
            formatter: (cellContent, row) => {
              return <></>;
            },
          },
          {
            dataField: "region",
            text: "Region",
            tableWidth: 22,
            expandWidth: 22,
            headerClasses: "bg-primary text-white px-sm-3 px-2 py-2",
            sort: true,
            hidden: !this.hasViewPermission(PermissionFeature.RegionCode),
            classes:
              "c-pointer px-3 py-2 border-right-0 border-left-0  bg-secondary text-white",
            formatter: (cellContent, row) => {
              return <></>;
            },
          },
          {
            dataField: "facility",
            text: "Facility",
            tableWidth: 23,
            expandWidth: 23,
            headerClasses: "bg-primary text-white px-sm-3 px-2 py-2",
            sort: true,
            hidden: !this.hasViewPermission(PermissionFeature.FacilityCode),
            classes:
              "c-pointer px-3 py-2 border-left-0 bg-secondary text-white",
            formatter: (cellContent, row) => {
              return <></>;
            },
          },
        ]
      : [
          {
            dataField: "status",
            text: this.hasViewPermission(PermissionFeature.GRGrievant)
              ? "Grievant"
              : "",
            tableWidth: this.hasViewPermission(PermissionFeature.GRGrievant)
              ? 10
              : !this.hasViewPermission(PermissionFeature.GRGrievant) &&
                !this.hasViewPermission(PermissionFeature.GRPARPDF)
              ? 10
              : 6,
            expandWidth: 6,
            headerClasses: "bg-primary text-white px-sm-3 px-2 py-2",
            sort: this.hasViewPermission(PermissionFeature.GRGrievant),
            onSort: async (field, order) => {
              if (this.hasViewPermission(PermissionFeature.GRGrievant)) {
                this.state.grievancesData = _.orderBy(
                  this.state.grievancesData,
                  ["grievant"],
                  [order]
                );
                await this.setState({
                  grievancesData: this.state.grievancesData,
                  filteredGrievances: this.arrangeDataWithStatus(
                    this.state.grievancesData,
                    this.state.sizePerPage,
                    this.state.page
                  ),
                });
              }
            },
            hidden:
              !this.hasViewPermission(PermissionFeature.GRGrievant) &&
              !this.hasViewPermission(PermissionFeature.GRPARPDF),
            classes:
              "c-pointer px-3 py-2 border-right-0 bg-secondary text-white",
            formatter: null,
          },
          {
            dataField: "dateFiled",
            text: "Date Filed",
            tableWidth: 10,
            expandWidth: 10,
            permission: PermissionFeature.GRDateFiled,
            headerClasses: "bg-primary text-white px-sm-3 px-2 py-2",
            hidden: !this.hasViewPermission(PermissionFeature.GRDateFiled),
            sort: true,
            classes:
              "px-3 c-pointer py-2 border-left-0 border-right-0 bg-secondary text-white",
            formatter: (cellContent, row) => {
              if (
                !this.hasViewPermission(PermissionFeature.GRGrievant) &&
                !this.hasViewPermission(PermissionFeature.GRPARPDF)
              ) {
                return <>{row.status}</>;
              } else {
                return <></>;
              }
            },
          },

          {
            dataField: "region",
            text: "Region",
            tableWidth: 7,
            expandWidth: 7,
            permission: PermissionFeature.RegionCode,
            headerClasses: "bg-primary text-white px-sm-3 px-2 py-2",
            sort: true,
            hidden: !this.hasViewPermission(PermissionFeature.RegionCode),
            classes:
              "px-3 c-pointer py-2 border-left-0 border-right-0 bg-secondary text-white",
            formatter: (cellContent, row) => {
              if (
                !this.hasViewPermission(PermissionFeature.GRGrievant) &&
                !this.hasViewPermission(PermissionFeature.GRPARPDF) &&
                !this.hasViewPermission(PermissionFeature.GRDateFiled)
              ) {
                return <>{row.status}</>;
              } else {
                return <></>;
              }
            },
          },
          {
            dataField: "facility",
            text: "Facility",
            tableWidth: 10,
            expandWidth: 10,
            permission: PermissionFeature.FacilityCode,
            headerClasses: "bg-primary text-white px-sm-3 px-2 py-2",
            hidden: !this.hasViewPermission(PermissionFeature.FacilityCode),
            sort: true,
            classes:
              "px-3 c-pointer py-2 border-left-0 border-right-0 bg-secondary text-white",
            formatter: (cellContent, row) => {
              if (
                !this.hasViewPermission(PermissionFeature.GRGrievant) &&
                !this.hasViewPermission(PermissionFeature.GRPARPDF) &&
                !this.hasViewPermission(PermissionFeature.GRDateFiled) &&
                !this.hasViewPermission(PermissionFeature.RegionCode)
              ) {
                return <>{row.status}</>;
              } else {
                return <></>;
              }
            },
          },
          {
            dataField: "step",
            text: "Step",
            tableWidth: 8,
            expandWidth: 8,
            permission: PermissionFeature.GRSteps,
            headerClasses: "bg-primary text-white px-sm-3 px-2 py-2",
            hidden: !this.hasViewPermission(PermissionFeature.GRSteps),
            sort: true,
            classes:
              "px-3 py-2 c-pointer border-left-0 border-right-0 bg-secondary text-white",
            formatter: (cellContent, row) => {
              if (
                !this.hasViewPermission(PermissionFeature.GRGrievant) &&
                !this.hasViewPermission(PermissionFeature.GRPARPDF) &&
                !this.hasViewPermission(PermissionFeature.GRDateFiled) &&
                !this.hasViewPermission(PermissionFeature.RegionCode) &&
                !this.hasViewPermission(PermissionFeature.FacilityCode)
              ) {
                return <>{row.status}</>;
              } else {
                return <></>;
              }
            },
          },
          {
            dataField: "subject",
            text: "Subject",
            tableWidth: 10,
            expandWidth: 10,
            permission: PermissionFeature.GRSubject,
            headerClasses: "bg-primary text-white px-sm-3 px-2 py-2",
            hidden: !this.hasViewPermission(PermissionFeature.GRSubject),
            sort: true,
            classes:
              "px-3 py-2 c-pointer border-left-0 border-right-0 bg-secondary text-white",
            formatter: (cellContent, row) => {
              if (
                !this.hasViewPermission(PermissionFeature.GRGrievant) &&
                !this.hasViewPermission(PermissionFeature.GRPARPDF) &&
                !this.hasViewPermission(PermissionFeature.GRDateFiled) &&
                !this.hasViewPermission(PermissionFeature.RegionCode) &&
                !this.hasViewPermission(PermissionFeature.FacilityCode) &&
                !this.hasViewPermission(PermissionFeature.GRSteps)
              ) {
                return <>{row.status}</>;
              } else {
                return <></>;
              }
            },
          },
          {
            dataField: "representative",
            text: "Representative",
            tableWidth: 13,
            expandWidth: 13,
            permission: PermissionFeature.GRRepresentative,
            headerClasses: "bg-primary text-white px-sm-3 px-2 py-2",
            hidden: !this.hasViewPermission(PermissionFeature.GRRepresentative),
            sort: true,
            classes:
              "px-3 py-2 c-pointer border-left-0 border-right-0 bg-secondary text-white",
            formatter: (cellContent, row) => {
              if (
                !this.hasViewPermission(PermissionFeature.GRGrievant) &&
                !this.hasViewPermission(PermissionFeature.GRPARPDF) &&
                !this.hasViewPermission(PermissionFeature.GRDateFiled) &&
                !this.hasViewPermission(PermissionFeature.RegionCode) &&
                !this.hasViewPermission(PermissionFeature.FacilityCode) &&
                !this.hasViewPermission(PermissionFeature.GRSteps) &&
                !this.hasViewPermission(PermissionFeature.GRSubject)
              ) {
                return <>{row.status}</>;
              } else {
                return <></>;
              }
            },
          },
          {
            dataField: "contractArticle",
            text: "Contract Article",
            tableWidth: 10,
            expandWidth: 10,
            permission: PermissionFeature.GRContractArticle,
            headerClasses: "bg-primary text-white px-sm-3 px-2 py-2",
            hidden: !this.hasViewPermission(
              PermissionFeature.GRContractArticle
            ),
            sort: true,
            classes:
              "px-3 py-2 c-pointer border-left-0 border-right-0 bg-secondary text-white",
            formatter: (cellContent, row) => {
              if (
                !this.hasViewPermission(PermissionFeature.GRGrievant) &&
                !this.hasViewPermission(PermissionFeature.GRPARPDF) &&
                !this.hasViewPermission(PermissionFeature.GRDateFiled) &&
                !this.hasViewPermission(PermissionFeature.RegionCode) &&
                !this.hasViewPermission(PermissionFeature.FacilityCode) &&
                !this.hasViewPermission(PermissionFeature.GRSteps) &&
                !this.hasViewPermission(PermissionFeature.GRSubject) &&
                !this.hasViewPermission(PermissionFeature.GRRepresentative)
              ) {
                return <>{row.status}</>;
              } else {
                return <></>;
              }
            },
          },
          {
            dataField: "remainingDays",
            text: "Remaining Days",
            tableWidth: 7,
            expandWidth: 7,
            headerClasses: "bg-primary text-white px-sm-3 px-2 py-2",
            hidden: !this.hasViewPermission(PermissionFeature.GRRemainingDays),
            sort: true,
            classes:
              "px-3 py-2 c-pointer border-left-0 border-right-0 bg-secondary text-white",
            formatter: (cellContent, row) => {
              if (
                !this.hasViewPermission(PermissionFeature.GRGrievant) &&
                !this.hasViewPermission(PermissionFeature.GRPARPDF) &&
                !this.hasViewPermission(PermissionFeature.GRDateFiled) &&
                !this.hasViewPermission(PermissionFeature.RegionCode) &&
                !this.hasViewPermission(PermissionFeature.FacilityCode) &&
                !this.hasViewPermission(PermissionFeature.GRSteps) &&
                !this.hasViewPermission(PermissionFeature.GRSubject) &&
                !this.hasViewPermission(PermissionFeature.GRRepresentative) &&
                !this.hasViewPermission(PermissionFeature.GRContractArticle)
              ) {
                return <>{row.status}</>;
              } else {
                return <></>;
              }
            },
          },

          {
            dataField: "id",
            text: "ID",
            tableWidth: 10,
            expandWidth: 10,
            headerClasses: "bg-primary text-white px-sm-3 px-2 py-2",
            sort: true,
            hidden: !this.hasViewPermission(PermissionFeature.Grievances),
            classes:
              "px-3 py-2 c-pointer border-left-0 border-right-0 bg-secondary text-white",
            formatter: (cellContent, row) => {
              if (
                !this.hasViewPermission(PermissionFeature.GRGrievant) &&
                !this.hasViewPermission(PermissionFeature.GRPARPDF) &&
                !this.hasViewPermission(PermissionFeature.GRDateFiled) &&
                !this.hasViewPermission(PermissionFeature.RegionCode) &&
                !this.hasViewPermission(PermissionFeature.FacilityCode) &&
                !this.hasViewPermission(PermissionFeature.GRSteps) &&
                !this.hasViewPermission(PermissionFeature.GRSubject) &&
                !this.hasViewPermission(PermissionFeature.GRRepresentative) &&
                !this.hasViewPermission(PermissionFeature.GRContractArticle) &&
                !this.hasViewPermission(PermissionFeature.GRRemainingDays)
              ) {
                return <>{row.status}</>;
              } else {
                return <></>;
              }
            },
          },
          {
            dataField: "actions",
            text: "",
            tableWidth: 5,
            expandWidth: 5,
            headerClasses: "bg-primary text-white px-sm-3 px-2 py-2",
            hidden:
              !this.hasViewPermission(PermissionFeature.GRPDFReport) &&
              !this.hasAddPermission(PermissionFeature.GRRequests) &&
              !this.hasUpdatePermission(PermissionFeature.GRRequests) &&
              !this.hasDeletePermission(PermissionFeature.GRRequests),
            sort: false,
            classes:
              "px-3 py-2 c-pointer border-left-0 border-right-0 bg-secondary text-white",
            formatter: (cellContent, row) => {
              if (
                !this.hasViewPermission(PermissionFeature.GRGrievant) &&
                !this.hasViewPermission(PermissionFeature.GRPARPDF) &&
                !this.hasViewPermission(PermissionFeature.GRDateFiled) &&
                !this.hasViewPermission(PermissionFeature.RegionCode) &&
                !this.hasViewPermission(PermissionFeature.FacilityCode) &&
                !this.hasViewPermission(PermissionFeature.GRSteps) &&
                !this.hasViewPermission(PermissionFeature.GRSubject) &&
                !this.hasViewPermission(PermissionFeature.GRRepresentative) &&
                !this.hasViewPermission(PermissionFeature.GRContractArticle) &&
                !this.hasViewPermission(PermissionFeature.GRRemainingDays) &&
                !this.hasViewPermission(PermissionFeature.Grievances)
              ) {
                return <>{row.status}</>;
              } else {
                return <></>;
              }
            },
          },
        ];
  }

  SizePerPageChange = (sizePerPage) => {
    this.setState({
      sizePerPage: sizePerPage,
      page: 1,
      filteredGrievances: this.arrangeDataWithStatus(
        _.cloneDeep(this.state.grievancesData),
        sizePerPage,
        1
      ),
    });
  };
  OnPageChange = (page) => {
    $(".loading").show();
    this.state.filteredGrievances = this.arrangeDataWithStatus(
      _.cloneDeep(this.state.grievancesData),
      this.state.sizePerPage,
      page
    );
    this.setState({
      page: page,
      filteredGrievances: this.state.filteredGrievances,
    });
    $(".loading").hide();
  };
  viewAllLink = (data) => {
    this.setState({ sizePerPage: data.length });
  };

  filterMyRequest = async (searchTerm, searchType, obj) => {
    let sTerm = Array.isArray(searchTerm) ? searchTerm : _.toLower(searchTerm);
    var searchStatus,
      searchkeyword,
      searchRegion,
      searchFacility,
      searchStep,
      searchArticle = "";
    let searchContract = this.state.searchTermContract;
    var currentGrievanceData = this.state.completeGrievancesList;
    switch (searchType) {
      case "keyword":
        this.state.searchkeyword = sTerm;
        searchkeyword = sTerm;

        break;
      case "status":
        this.state.searchTermStatus = sTerm;
        searchStatus = sTerm;
        this.setState({ searchTermStatus: this.state.searchTermStatus });

        break;
      case "region":
        this.state.searchTermRegion = sTerm;
        searchRegion = sTerm;
        if (!_.isEmpty(this.state.completeFacilities)) {
          if (obj) {
            this.state.facilities = this.state.completeFacilities.filter(
              (x) => x.regionId == obj.regionId
            );
          } else {
            this.state.facilities = this.state.completeFacilities;
          }
          await this.setState({
            facilities: this.state.facilities,
            searchTermFacility: "",
            facility: {},
            region: obj,
          });
        }
        break;

      case "contract": {
        this.state.searchTermContract = sTerm;
        searchContract = sTerm;
        this.state.searchTermArticle = "";
        searchArticle = "";
        await this.setState({
          searchTermArticle: this.state.searchTermArticle,
          searchTermContract: this.state.searchTermContract,
        });
        await this.filterArticlesBasedOnContracts(searchContract);
        break;
      }

      case "article":
        this.state.searchTermArticle = sTerm;
        searchArticle = sTerm;
        break;
      case "facility":
        this.state.searchTermFacility = sTerm;
        searchFacility = sTerm;
        await this.setState({ facility: obj });

        break;
      case "steps":
        this.state.searchStep = sTerm;
        searchStep = sTerm;
        await this.setState({ searchStep: this.state.searchStep });

        break;
      default:
        break;
    }
    let thiss = this;
    if (this.state.searchkeyword) {
      currentGrievanceData = _.filter(currentGrievanceData, function(item) {
        return _.toLower(item.subject).indexOf(thiss.state.searchkeyword) > -1;
      });
    }
    if (this.state.searchTermStatus && this.state.searchTermStatus != "0") {
      currentGrievanceData = _.filter(currentGrievanceData, function(item) {
        return (
          _.toLower(item.status).indexOf(thiss.state.searchTermStatus) > -1
        );
      });
    }
    if (this.state.searchTermRegion) {
      currentGrievanceData = _.filter(currentGrievanceData, function(item) {
        return (
          _.toLower(item.region).indexOf(thiss.state.searchTermRegion) > -1
        );
      });
    }
    if (this.state.searchTermFacility) {
      currentGrievanceData = _.filter(currentGrievanceData, function(item) {
        return (
          _.toLower(item.facilityCode).indexOf(thiss.state.searchTermFacility) >
          -1
        );
      });
    }
    // Check if searchStep exists and is an array with values
    if (this.state.searchStep && this.state.searchStep.length > 0) {
      currentGrievanceData = _.filter(currentGrievanceData, function(item) {
        // Check if the item's step is included in the selected steps array

        return thiss.state.searchStep.some(
          (x) => _.toLower(x) === _.toLower(item.step)
        );
      });
    }
    if (this.state.searchTermArticle) {
      currentGrievanceData = _.filter(currentGrievanceData, function(item) {
        return (
          item.articles &&
          !_.isEmpty(item.articles) &&
          item.articles.some((article) => {
            return article.id === parseInt(thiss.state.searchTermArticle);
          })
        );
      });
    }
    if (this.state.searchTermContract) {
      currentGrievanceData = _.filter(currentGrievanceData, function(item) {
        return (
          item.articles &&
          !_.isEmpty(item.articles) &&
          item.articles.some((article) => {
            return article.contractId === parseInt(searchContract);
          })
        );
      });
    }

    this.setState({
      filteredGrievances: this.arrangeDataWithStatus(
        _.cloneDeep(currentGrievanceData),
        this.state.sizePerPage,
        1
      ),
      grievancesData: currentGrievanceData,
      page: 1,
      grievanceCount: currentGrievanceData.length,
    });
    this.expandAll();
  };

  handleClearSearch() {
    $("#status").val("0");
    $("#region").val("0");
    this.setState({
      searchTerm: "",
      searchType: "",
      searchTermStatus: "0",
      searchTermRegion: "",
      searchTermFacility: "",
      searchTermArticle: "",
      searchTermContract: "",
      searchStep: "",
      contractArticles: [],
      searchkeyword: "",
      isClean: true,
      facility: {},
      region: {},
      showClearButton: false,
      facilities: this.state.completeFacilities,
      filteredGrievances: this.arrangeDataWithStatus(
        this.state.completeGrievancesList,
        this.state.sizePerPage,
        1
      ),
      page: 1,
      grievancesData: this.state.completeGrievancesList,
      grievanceCount: this.state.completeGrievancesList.length,
    });
    this.expandFirst();
  }

  openFilterModal() {
    this.setState({
      isSearchModalOpen: true,
    });
  }

  render() {
    Font.register({
      family: "Open Sans",
      fonts: [
        {
          src:
            "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf",
        },
        {
          src:
            "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-300.ttf",
          fontWeight: "light",
        },
      ],
    });
    const { showDeleteModal, showBulkDeleteModal, itemToDelete } = this.state;

    const styles = makeStyles({
      GrienvantSecondFooter: {
        marginTop: 10,
        textDecoration: "underline",
        fontSize: 13,
        fontWeight: "500",
      },
      grievanceHeaderLeft: {
        width: "100%",
        float: "left",
      },
      grievanceHeaderRight: {
        width: "50%",
        marginLeft: 330,
        marginTop: -30,
        float: "right",
      },
      headerImageView: {
        marginLeft: 100,
      },
      GrienvantFooter: {
        marginTop: 30,
      },
      image: {
        width: 80,
        height: 80,
        float: "left",
      },
      floatLeft: {
        float: "left",
      },
      sec: {
        //marginTop: 80
      },
      Dear: {
        marginTop: 30,
        marginBottom: 30,
      },
      afterSalution: {
        marginTop: 10,
      },
      afterDateText: {
        marginTop: 30,
      },
      dateText: {
        marginTop: 50,
      },
      logoImage: {
        width: 80,
        height: 80,
      },
      body: {
        paddingTop: 35,
        paddingBottom: 65,
        fontSize: 12,
        paddingHorizontal: 35,
      },
      title: {
        fontSize: 24,
        textAlign: "left",
        marginTop: 20,
        fontFamily: "Oswald",
      },
      author: {
        fontSize: 12,
        textAlign: "center",
        marginBottom: 40,
      },
      subtitle: {
        fontSize: 18,
        margin: 12,
        fontFamily: "Oswald",
      },
      text: {
        margin: 12,
        fontSize: 14,
        textAlign: "justify",
        fontFamily: "Times-Roman",
      },

      header: {
        fontSize: 12,
        marginBottom: 20,
        textAlign: "center",
        color: "grey",
      },
      pageNumber: {
        position: "absolute",
        fontSize: 12,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: "center",
        color: "grey",
      },
    });
    let classes = makeStyles({
      option: {
        fontSize: 10,
        "& > span": {
          marginRight: 10,
          fontSize: 10,
        },
        backgroundColor: "white",
      },
      customTextField: {
        "& input::placeholder": {
          fontSize: "15px",
        },
      },
    });
    return (
      <AUX>
        <GrievanceHeader
          changeActiveTab={this.changeActiveTab}
          ActiveTab={this.state.ActiveTab}
        />
        <div className="pac-container container-fluid">
          <div className="row mx-0 pt-4">
            <div className="col-md-3">
              <form role="search" className="app-search mt-0">
                <MDBInput
                  name="keyword"
                  size="lg"
                  hint="Search Subject"
                  variant="outlined"
                  style={{ width: "100%" }}
                  value={this.state.searchkeyword}
                  onChange={(e) => {
                    if (e.target.value) {
                      e.preventDefault();
                      this.filterMyRequest(
                        e.target.value,
                        "keyword",
                        e.target.value
                      );
                    } else {
                      this.handleClearSearch();
                    }
                  }}
                  placeholder="Search By Subject"
                  type="text"
                />
              </form>
            </div>
            <div className="col-md-6">
              <button
                type="button"
                className="c-pointer mb-1 px-3 btn btn-sm btn-outline-success pl-2"
                style={{
                  marginTop: "25px",
                  marginLeft: "35px",
                  height: "45px",
                }}
                onClick={() => {
                  this.openFilterModal(true);
                }}
              >
                <i class="cursorPointer pr-1 fab fa-searchengin" />
                More Filters
              </button>
              <div className="float-left" />
            </div>
            <div className="col-md-3 d-flex flex-column">
              <div class="mt-auto">
                <PDFDownloadLink
                  document={
                    <PARMultiPdfDocument
                      data={this.state.selectedGrievancePARDATA}
                    />
                  }
                  fileName={
                    "PAR-" +
                    this.state.parPDFRegion +
                    "-" +
                    new Date().toISOString().split("T")[0] +
                    ".pdf"
                  }
                  className="d-inline-block"
                >
                  {({ blob, url, loading, error }) => {
                    return (
                      <div>
                        {this.state.showPARPDF && (
                          <button className="btn d-inline-block btn-success btn-x-sm btn-sm ml-sm-2 ml-1 w-md waves-effect waves-light mb-2">
                            Download PAR
                          </button>
                        )}
                      </div>
                    );
                  }}
                </PDFDownloadLink>
                {this.state.selectedGrievanceForPAR.filter(
                  (x) => x.allowedDelete
                ).length > 0 && (
                  <button
                    className="btn d-inline-block btn-danger btn-x-sm btn-sm ml-sm-2 ml-1 w-md waves-effect waves-light mb-2"
                    onClick={this.handleBulkDeleteClick}
                  >
                    Delete Grievances
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="page-title-box" />
          <div className="row" id="tableRow">
            <div className="col-12" style={{ overflow: "scroll" }}>
              {!_.isEmpty(this.state.filteredGrievances) ? (
                this.RemotePagination(
                  this.getVisibleColumns(),
                  "status",
                  this.state.filteredGrievances, //this.filterMyRequest(),
                  this.SizePerPageChange,
                  this.state.sizePerPage,
                  this.rowClasses
                )
              ) : this.state.loadState ? (
                <p className="mt-4 text-center">Loading... please wait.</p>
              ) : (
                <p className="mt-4 text-center">No Grievances Are Available</p>
              )}
            </div>
          </div>
          <GrievanceDetailsOnlyModal
            modal={this.state.isConfirmModalOpen}
            toggle={this.toggleConfirmModal}
            data={this.state.grievanceViewOnlyData}
            grievanceId={this.state.selectedGrievanceForDetail}
            grievanceStatus={this.state.selectedGrievanceStatus}
            reActive={this.reActiveGrievance}
          />
          <GrievanceSearchModal
            modal={this.state.isSearchModalOpen}
            toggle={this.toggleSearchModel}
            statuses={this.state.statuses}
            facilities={this.state.facilities}
            searchTermArticle={this.state.searchTermArticle}
            searchTermContract={this.state.searchTermContract}
            articlesList={this.state.contractArticles}
            articleValue={this.state.contractArticle}
            regions={this.state.regions}
            searchTermStatus={this.state.searchTermStatus}
            contractList={this.state.contractList}
            filterMyRequest={this.filterMyRequest}
            facilityValue={this.state.facility}
            regionValue={this.state.region}
            stepsList={this.state.stepsList}
            searchStep={this.state.searchStep}
            grievanceCount={this.state.grievanceCount}
            handleClearSearch={this.handleClearSearch}
          />
        </div>
        {this.hasAddPermission(PermissionFeature.GRRequests) && (
          <GrievanceGridDuplicateForm
            GrievanceId={this.state.currentDuplicateGrievanceId}
            ShowModal={this.state.showDuplicateGrievanceModal}
            OnClose={this.closeDuplicateGrievanceModal}
          />
        )}
        {this.hasUpdatePermission(PermissionFeature.GRRequests) && (
          <GrievanceEditForm
            GrievanceId={this.state.currentEditGrievanceId}
            ShowModal={this.state.showEditGrievanceModal}
            OnClose={this.closeEditGrievanceModal}
          />
        )}
        {this.hasDeletePermission(PermissionFeature.GRRequests) && (
          <>
            <DeleteConfirmModal
              show={showDeleteModal}
              item={itemToDelete}
              onConfirm={this.confirmDelete}
              onCancel={this.cancelDelete}
            />
            <DeleteBulkConfirmModal
              show={showBulkDeleteModal}
              onConfirm={this.deleteGrievances}
              onCancel={this.cancelBulkDelete}
            />
          </>
        )}
      </AUX>
    );
  }
}
export default withRouter(
  connect((state) => ({ grievanceState: state.grievances }), {
    ...GrievanceAction,
  })(Grievances)
);
